import Spline from "@splinetool/react-spline";
import { StyleSheet, View } from "react-native";
import AssessmentOrbController from "./AssessmentOrbController";
import { useRef } from "react";
import { Application } from "@splinetool/runtime";
import Loader from "../../components/common/status/Loader/Loader";

interface AssessmentSpeakingOrbProps {
  dynamicHeight: number;
  orbLoading: boolean;
  setOrbLoading: (loading: boolean) => void;
}

const AssessmentSpeakingOrb = ({ dynamicHeight, orbLoading, setOrbLoading }: AssessmentSpeakingOrbProps) => {
  const orb = useRef(null);

  const onLoad = (spline: Application) => {
    setOrbLoading(false);
    const obj = spline.findObjectById("02f9e61e-081c-484d-8258-c53281906a3f");
    orb.current = obj;
  };

  return (
    <View style={[styles.orbContainer, { height: dynamicHeight }]}>
      {orbLoading && <Loader />}
      <Spline scene="https://prod.spline.design/eGVArbV9JzcVNsir/scene.splinecode" onLoad={onLoad} />
      <AssessmentOrbController orb={orb} />
    </View>
  );
};

const styles = StyleSheet.create({
  orbContainer: {
    justifyContent: "center",
    alignItems: "center",
  },
});

export default AssessmentSpeakingOrb;
